<template>
  <Card :class="[`${$route.name.split('-').shift()}-mutate-customfields`]">
    <CustomFields
      :value="value"
      @input="e => $emit('updateValue', e)"
      :schema="customFieldSchemasComp"
      :data="data"
      :placement="customFieldsPlacement"
      :validator="validator"
      validator-prefix="customFields"
    />
  </Card>
</template>

<script>
import Card from '@/components/Card'
import CustomFields from '@kvass/custom-fields'
import { mergeDeepRight } from 'ramda'

const meta = {
  skip: true,
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    customFieldsPlacement: { type: Array, default: () => [] },
    isActive: Boolean,
  },
  computed: {
    customFieldSchemasComp() {
      return this.customFieldSchemas.map(item => {
        //blocks without fields (e.g. lead-form) have no options
        return mergeDeepRight(item, {
          options: { props: { ...this.$path('options.props', item), parentIsActive: this.isActive } },
        })
      })
    },
  },
  components: {
    Card,
    CustomFields,
  },
}
</script>
